/*
 * @Author: liyihui
 * @Date:
 * @description:  接口请求访问地址 gw-management微服务总集 
 * @Last Modified by:
 * @Last Modified time:
 */

import { XAget, XApost, XAput, XAdel } from '@/utils/requestTeamXA.js';

// 微服务地址
const serviceAddress = 'official-site-java/ow_show/';
// 四种请求
export function gwManageGET(address, data, func) {
	XAget(serviceAddress + address, data).then(res => { func(res); });
}
export function gwManagePOST(address, data, func) {
	XApost(serviceAddress + address, data).then(res => { func(res); });
}
export function gwManagePUT(address, data, func) {
	XAput(serviceAddress + address, data).then(res => { func(res); });
}
export function gwManageDEL(address, data, func) {
	XAdel(serviceAddress + address, data).then(res => { func(res); });
}


// 放出本微服务API接口合集
import enterpriseAPI from './enterprise';
import aboutUsAPI from './aboutUs'
import productAPI from './product'

const API = {
	...enterpriseAPI,
	...aboutUsAPI,
	...productAPI,
}

export default API;



// WEBPACK FOOTER //
// ./src/api/gwManage/index.js